var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.583,
    height: 11.583,
    viewBox: "88.55 16.787 11.583 11.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.305 21.338h-3.723v-3.724a.827.827 0 0 0-.827-.827h-.827a.827.827 0 0 0-.828.827v3.724h-3.723a.827.827 0 0 0-.827.827v.827c0 .457.37.828.827.828H93.1v3.723c0 .457.37.827.828.827h.827c.457 0 .827-.37.827-.827V23.82h3.723c.457 0 .828-.37.828-.828v-.827a.827.827 0 0 0-.828-.827Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon awesome-plus"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.31c025cd686214dab457b638721481d0.svg";
export { ForwardRef as ReactComponent };